"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarlyOfferCredit = void 0;
const class_validator_1 = require("class-validator");
class EarlyOfferCredit {
    _id;
    userId;
    amount;
    validFrom;
    validTo;
    createdAt;
    createdByUserId;
    deactivatedAt;
    isDefault;
    note;
}
exports.EarlyOfferCredit = EarlyOfferCredit;
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], EarlyOfferCredit.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], EarlyOfferCredit.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], EarlyOfferCredit.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], EarlyOfferCredit.prototype, "validFrom", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], EarlyOfferCredit.prototype, "validTo", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], EarlyOfferCredit.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], EarlyOfferCredit.prototype, "createdByUserId", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Date)
], EarlyOfferCredit.prototype, "deactivatedAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], EarlyOfferCredit.prototype, "isDefault", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], EarlyOfferCredit.prototype, "note", void 0);
//# sourceMappingURL=EarlyOfferCredit.js.map